module.exports = __webpack_public_path__ + "img/unisafety-logo.a17c1bee.png";